/*
 * Build initial values when currency param available
 */
export const buildInitials = (currencies, currencyParam, isCrypto) => {
	const currency = currencies.find(c => c.abbreviature === currencyParam)
	return {
		...currency,
		value: currency.id,
		isCrypto
	}
}

/*
 * Replace string by key words
 */
export const strReplace = (str, name, abbr) => {
	let newStr = str.replace('{name}', name)
	newStr = newStr.replace('{abbr}', abbr)
	return newStr
}
